export function obterListaMdfeTpAntecip() {
  return (
    [
      { label: '0 - Não Permitir antecipar', value: 'NAOPERMITIR' },
      { label: '1 - Permitir antecipar as parcelas', value: 'PERMITIR' },
      { label: '2 - Permitir antecipar as parcelas mediante confirmação', value: 'PERMITIRMEDIANTECONFIRMACAO' },
    ]
  );
}
